/**
 * 缓动滚动某段距离
 * @param {dom} container 滚动容器
 * @param {Number} distance 相对当前所处位置的滚动距离，负值表示向下滚动，正值表示向上滚动
 * @param {Number} duration 滚动时长，毫秒
 * @param {Function} cb 滚动结束回调
 * @param {String} type 缓动函数，可选值 'ease-in', 'ease-out', 'ease-in-out', 默认值为 'ease-out'
 * @param {String} direction 滚动方向，可选值 'vertical', 'horizontal', 默认值为 'vertical'
 */

const getEaseIn = (t, b, c, d) => c * (t /= d) * t + b;
const getEaseOut = (t, b, c, d) => -c * (t /= d) * (t - 2) + b;
const getEaseInOut = (t, b, c, d) => {
  if ((t /= d/2) < 1) return c/2 * t * t + b;
  return -c/2 * ((--t) * (t - 2) - 1) + b;
};
const raf = window['requestAnimationFrame'] || window['webkitRequestAnimationFrame'];

function scrollToDistance (container, distance, duration, cb, type, direction = 'vertical') {
  // 滑动开始的时间
  let start = 0;
  // 已经执行的时间
  let executedTime = 0;
  // 缓动函数
  const easeFunc = type === 'ease-in' ? getEaseIn : (type === 'ease-in-out' ? getEaseInOut : getEaseOut);

  const key = direction === 'horizontal' ? 'scrollLeft' : 'scrollTop';
  
  const startScrollPos = container[key];

  const scroll = timestamp => {
    if (start > 0) executedTime = timestamp - start;
    else start = timestamp;
    if (executedTime >= duration) {
      //滑动完成
      container[key] = distance + startScrollPos;
      cb && cb();
      return;
    }
    // 滑动未完成
    container[key] = easeFunc(executedTime, startScrollPos, distance, duration);

    raf(scroll);
  };

  raf(scroll);
}

export default scrollToDistance;


// WEBPACK FOOTER //
// ./node_modules/@kk/utils/src/scrollToDistance.js